<template>
  <div id="app">
    <keep-alive include="page-index,page-index-search">
      <router-view></router-view>
    </keep-alive>
    <!-- 关注公众号 已屏蔽 -->
    <div v-if="showGzhPopup && false" class="popup-gz" ref="popupGz">
      <div class="mask"></div>
      <div class="index-wrap">
        <div class="title">关注公众号</div>
        <img src="@/common/image/ewm-02.jpg" alt />
        <div class="con">长按或微信扫描关注我，随时观看精彩课程</div>
        <a class="btn-bind" @click="toBind" v-show="user && !user.is_golo_user">绑定golo账号</a>
        <div class="cha">
          <span @click="showGzhPopup = false">×</span>
        </div>
      </div>
    </div>
    <!-- 2018圣诞活动 -->
    <!--<div ref="christmas">-->
    <!--<christmas v-if="christ&&!disabled" @close="christ = false"></christmas>-->
    <!--</div>-->
    <!-- 新年优惠券 -->
    <!-- <new-year></new-year> -->
    <!-- 引导购买vip --->
    <!-- <Vip></Vip> -->
    <div class="popup-login" v-if="needLogin">
      <div class="mask"></div>
      <div class="main">
        <div class="container">
          <div>请完成手机绑定</div>
          <a class="login-btn" @click="toLogin">去绑定</a>
        </div>
        <div class="close">
          <!--<i class="iconfont icon-close1" @click="$router.push('/index')"></i>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isWeixin } from '@/common/js/util.js'
import { browse } from '@/api/browse'
import { mapGetters, mapMutations, mapActions } from 'vuex'
// import Christmas from '@/components/base/activity/christmas'
// import {getCoupon, show} from '@/api/activity/christmas'
// import NewYear from '@/components/base/activity/newyear'
// import Vip from '@/components/base/activity/vip'

export default {
  data() {
    return {
      showGzhPopup: false
      // 圣诞活动
      // christ: false, // 判断是否弹窗
      // disabled: false
    }
  },
  computed: {
    ...mapGetters(['user', 'needLogin'])
  },
  beforeCreate() {
  },
  created() {
    let rootHtml = document.documentElement
    let newWidth = rootHtml.clientWidth >= 768 ? 600 : rootHtml.clientWidth
    rootHtml.style.fontSize = `${newWidth / (375 / 16)}px`
    // 设置Vuex.state.isWeixin微信浏览器
    this.setBrowser(isWeixin)
    // 2018圣诞活动
    /** getCoupon().then(res => {
      const data = res.data
      if (data && data.code === 1 && !this.disabled) {
        // 看看弹出控制的规则
        this.christ = show()
      } else if (data && data.msg) {
        // 打印下用于调试
        console.log(data.msg)
      }
    })**/
    // 获取用户信息, 保存到vuex
    this.getUser()
    setTimeout(() => {
      browse().then(res => {
        console.log('已浏览5分钟,向后台发送请求.')
        console.log(res)
      }).catch(error => {
        console.log(error)
      })
    }, 1000 * 60 * 5) // 浏览满5分钟发送请求
  },
  methods: {
    toBind() {
      this.$router.push({ path: '/personal/bind/bind' })
      this.showGzhPopup = false
    },
    toLogin() {
      if (isWeixin) {
        window.location.href = '/third/connect/wechat?auth_callback=' + encodeURIComponent(location.pathname + location.hash)
      } else {
        window.location.href = '/addons/third/index/verification?type=mobile&auth_callback=' + encodeURIComponent(location.pathname + location.hash)
      }
    },
    ...mapMutations({
      setBrowser: 'SET_ISWEIXIN'
    }),
    ...mapActions(['getUser'])
  },
  components: {
    // Christmas
    // NewYear
    // Vip
  },
  watch: {
    user(n) {
      // 弹出关注公众号框逻辑
      let timer = localStorage.getItem('gzhPopupTimestamp')
      // 没有记录或者记录大于三天
      if (!timer || (timer && (new Date().getTime() - timer) > (3 * 24 * 60 * 60 * 1000))) {
        // 如果未关注
        if (!n.is_subscribe) {
          // 弹出关注公众号
          this.showGzhPopup = true
          // 三天内不再弹出
          localStorage.setItem('gzhPopupTimestamp', new Date().getTime())
        }
      }
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
@import '~common/stylus/variable';

.mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 998;
}

.index-wrap {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background: #ffffff;
  font-size: size(32);
  text-align: center;
  min-width: 60%;
  padding: size(30) size(24) size(40);
  border-radius: 4px;

  img {
    display: block;
    width: size(200);
    margin: size(18) auto size(24);
  }
}

.title {
  font-size: size(30);
  line-height: 2;
  color: #333;
  font-weight: 800;
}

.con {
  font-size: size(24);
  line-height: 1.6;
}

.cha {
  position: absolute;
  text-align: center;
  width: 100%;
  left: 0;
  bottom: size(-90);
  color: #fff;

  >span {
    display: inline-block;
    color: #fff;
    font-size: size(40);
    width: size(44);
    height: size(44);
    border-radius: 50%;
    border: 1px solid #fff;
    line-height: size(36);
    text-align: center;
  }
}

.btn-bind {
  display: block;
  width: 80%;
  background-color: #ff6c00;
  margin: size(20) auto 0;
  padding-top: size(16);
  padding-bottom: size(16);
  color: #fff;
  font-size: size(28);
  -webkit-border-radius: size(8);
  -moz-border-radius: size(8);
  border-radius: size(8);
}

.popup-login {
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99999;
  }

  .main {
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    color: #222;
    z-index: 100000;
    font-size: size(26);
    width: size(610);

    .container {
      max-height: 72.4vh;
      padding: size(30);
      overflow-y: scroll;
      background-color: #fff;
      -webkit-border-radius: size(20);
      -moz-border-radius: size(20);
      border-radius: size(20);
      -webkit-overflow-scrolling: touch;
      text-align: center;
      font-size: size(32);
      line-height: 1.5;
      padding: size(34);

      .title {
        color: #2eacb9;
        text-align: center;
        font-size: size(34);
        font-weight: 800;
      }

      >.group {
        padding-top: size(32);

        .title2 {
          font-size: size(28);
          position: relative;
          display: inline-block;
          z-index: 2;

          &:after {
            content: '';
            display: inline-block;
            position: absolute;
            bottom: -1px;
            right: size(-12);
            left: size(-12);
            height: size(18);
            background-color: #35218e;
            z-index: -1;
            transform: skewX(-20deg);
          }
        }

        .content {
          margin-top: size(20);
          line-height: 1.4;

          .row {
            margin-bottom: size(20);

            .item {
              padding-left: size(16);
            }
          }
        }
      }

      .login-btn {
        display: inline-block;
        width: size(218);
        height: size(74);
        line-height: size(74);
        background-color: #fff;
        -webkit-border-radius: size(37);
        -moz-border-radius: size(37);
        border-radius: size(37);
        color: #222;
        margin-top: size(44);
        border: 1px solid #666;
      }
    }

    >.close {
      text-align: center;
      margin-top: size(46);

      i {
        font-size: size(60);
        color: #666;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/index.vue